import { useEffect, useState } from "react"
import { useAuth0 } from "@auth0/auth0-react"
import { getApiBaseUrl } from "../../config/apiBase"

export default function useGroupWorkspaceAccess(groupId) {
  const { isLoading, isAuthenticated, getAccessTokenSilently } = useAuth0()
  const [result, setResult] = useState(null)
  useEffect(() => {
    let cancelled = false
    const save = (status) => {
      if (!cancelled) setResult({ groupId, status })
    }
    setResult(null)
    if (isLoading) return () => { cancelled = true }
    if (!isAuthenticated) {
      save("public")
      return () => { cancelled = true }
    }
    const check = async () => {
      try {
        const token = await getAccessTokenSilently({ authorizationParams: { audience: process.env.REACT_APP_API_AUDIENCE } })
        const response = await fetch(`${getApiBaseUrl()}/api/GroupsTbls/${groupId}/workspace-access`, {
          headers: { Authorization: `Bearer ${token}` },
        })
        save(response.ok ? "allowed" : response.status === 403 ? "public" : response.status === 404 ? "missing" : "error")
      } catch {
        save("error")
      }
    }
    check()
    return () => { cancelled = true }
  }, [groupId, isLoading, isAuthenticated, getAccessTokenSilently])
  if (isLoading) return "loading"
  if (!isAuthenticated) return "public"
  return result?.groupId === groupId ? result.status : "loading"
}
